import api from './api';

const API_URL = '/administration/events';

export interface SchoolEvent {
  _id: string;
  title: string;
  description?: string;
  date: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
  categoryId: {
    _id: string;
    name: string;
    color?: string;
  } | string;
  location?: string;
  isAllDay: boolean;
  status: 'UPCOMING' | 'COMPLETED' | 'CANCELLED';
  isRecurring: boolean;
  parentEventId?: string | null;
  createdBy?: { _id: string; name: string } | string;
  schoolId: string;
  isActive: boolean;
}

export interface CreateEventData {
  title: string;
  description?: string;
  date: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
  categoryId: string;
  location?: string;
  isAllDay: boolean;
  isRecurring: boolean;
}

interface GetEventsParams {
  year?: number;
  month?: number;
  categoryId?: string;
  status?: string;
}

const getEvents = async (params?: GetEventsParams): Promise<SchoolEvent[]> => {
  const response = await api.get(API_URL, { params });
  return response.data.data;
};

const getEventById = async (id: string): Promise<SchoolEvent> => {
  const response = await api.get(`${API_URL}/${id}`);
  return response.data.data;
};

const createEvent = async (data: CreateEventData): Promise<SchoolEvent> => {
  const response = await api.post(API_URL, data);
  return response.data.data;
};

const updateEvent = async (id: string, data: Partial<CreateEventData>): Promise<SchoolEvent> => {
  const response = await api.put(`${API_URL}/${id}`, data);
  return response.data.data;
};

const deleteEvent = async (id: string): Promise<void> => {
  await api.delete(`${API_URL}/${id}`);
};

const updateEventStatus = async (id: string, status: string): Promise<SchoolEvent> => {
  const response = await api.patch(`${API_URL}/${id}/status`, { status });
  return response.data.data;
};

const eventService = {
  getEvents,
  getEventById,
  createEvent,
  updateEvent,
  deleteEvent,
  updateEventStatus
};

export default eventService;
